
import {Component, Mixins, Watch, Prop, Ref} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import AlacakTuruPicker from "@/components/pickers/AlacakTuruPicker.vue";
import {AlacakBelgeTuru} from "@/enum/AlacakBelgeTuru";
import {ParaBirimi} from "@/enum/ParaBirimi";
import Faizler from "@/components/forms/Faizler.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import {AlacakKalemiTuru} from "@/enum/AlacakKalemiTuru";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import Kur from "@/components/inputs/Kur.vue";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import {TakipTipi} from "@/enum/TakipTipi";
import {NakakaEnum} from "@/enum/NafakaEnum";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";


@Component({
  components: {
    Kur,
    ParaBirimiPicker,
    AlacakTuruPicker,
    Tutar,
    Dates,
    Faizler,
    FormWrapper,
    DovizTakipSekliPicker
  },
})
export default class NafakaAlacakKalemiForm extends Mixins(ObjectInputMixin) {
  @Prop() hideButtons!: boolean | string;
  @Prop() takipTipiId!: number;
  @Prop() alacak!: AlacakEntity;
  @Ref('form') readonly form!: FormWrapper;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Prop({default: false}) defaultFirstItem!: boolean;

  readonlyParaBirimi = false;
  paraBirimi = ParaBirimi;
  AlacakBelgeTuru = AlacakBelgeTuru;
  AlacakKalemiTuru = AlacakKalemiTuru;
  AlacakKalemiAlani = AlacakKalemiAlani;
  dovizTakipSekli = DovizTakipSekli;
  NakakaEnum = NakakaEnum;
  paraBirimleri:Array<ParaBirimi>=[]
  showConfirmDialog: boolean = false;
  devamEdenAylarIcinGecerli: boolean = true;
  originalTutar: any = null;
  originalTutarSet: boolean = false;

  get showOzneBilgileri(): boolean {
    const turuId = this.localValue.alacak_kalemi_turu_id;
    return turuId === NakakaEnum.istirak_nafakasi || turuId === NakakaEnum.yoksulluk_nafakasi;
  }

  get ozneBilgileriLabel(): string {
    const turuId = this.localValue.alacak_kalemi_turu_id;
    if (turuId === NakakaEnum.yoksulluk_nafakasi) {
      return 'Eşin Adı';
    }
    if (turuId === NakakaEnum.istirak_nafakasi) {
      return 'Çocuğun Adı';
    }
    return '';
  }

  async save(){
    if (this.alacak.id){
      this.localValue.alacak_id = this.alacak.id

      if (!this.localValue.id) {
        this.localValue.alacak_kalemi_alani_id = AlacakKalemiAlani.asilAlacak
      }

      if (this.alacak.alacak_belge_turu_id !== this.AlacakBelgeTuru.apartman_alacagi){
        this.localValue.gecikme_tazminati_mi = false
      }else{
        if (this.localValue.gecikme_tazminati_mi){
          this.localValue.gecikme_tazminati_mi = true
        }else{
          this.localValue.gecikme_tazminati_mi = false
        }
      }

      if (this.localValue.id){
        if (String(this.localValue.tutar) !== String(this.originalTutar)) {
          // Tutar değişmişse onay dialog'u aç
          this.showConfirmDialog = true;
        } else {
          // Tutar değişmemişse direkt güncelle
          await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id, this.localValue);
          this.$emit("onSuccess");
        }
        if (this.localValue.elle_faiz_oran_mi) {
          if (this.localValue.elle_faiz_mi && this.localValue.takip_sonrasi_faiz_turu) {
            const faizTuruId = await this.$helper.saveFaizTuru(this.localValue.takip_sonrasi_faiz_turu, this.$route.params.id);
            this.localValue.takip_oncesi_faiz_turu_id = faizTuruId;
            this.localValue.takip_sonrasi_faiz_turu_id = faizTuruId;
          } else {
            this.localValue.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(this.localValue.takip_oncesi_faiz_turu, this.$route.params.id);
            this.localValue.takip_sonrasi_faiz_turu_id = this.localValue.takip_oncesi_faiz_turu_id;
          }
        }
        await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id,this.localValue);
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }else{
        await this.$http.post('/api/v1/alacak/' + this.alacak.id + '/alacak-kalemi',this.localValue);
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }
    }else{
      this.$emit("addAsilAlacak",this.localValue);
      this.$emit("onSuccess");
    }
  }

  async confirmUpdate(){
    this.localValue.is_devam_eden_aylar = this.devamEdenAylarIcinGecerli;
    this.localValue.update_alacak_tutar = true;
    await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id, this.localValue)
    this.showConfirmDialog = false;
    this.devamEdenAylarIcinGecerli = true;
    this.$emit("onSuccess");
  }

  cancelUpdate(){
    this.showConfirmDialog = false;
    this.devamEdenAylarIcinGecerli = true;
  }

  /*get nafakaLabel() {
    if (this.localValue.alacak_kalemi_turu?.id == AlacakKalemiTuru.yargilamaGideri)
      return 'Yargılama Gideri Tutarı';
    else if (this.localValue.alacak_kalemi_turu?.id == AlacakKalemiTuru.mahkemeVekaletUcreti)
      return 'Vekalet Ücreti Tutarı'
    else
      return 'Aylık Nafaka Tutarı'
  }*/

  get isIlamliTakip(): boolean {
    return this.$helper.isIlamliTakipFromTakipStore();
  }

  get tarih() {
    if (this.localValue.vade_tarihi) {
      return this.localValue.vade_tarihi;
    } else if (this.localValue.ibraz_tarihi) {
      return this.localValue.ibraz_tarihi;
    }
  }

  @Watch('localValue.para_birimi_id')
  onParaBirimiIdChange() {
    this.addParaBirimi();
  }

  addParaBirimi() {
    if (this.localValue.takip_tarihli_kurlar &&
        this.localValue.para_birimi_id != ParaBirimi.TRY &&
        !this.localValue.takip_tarihli_kurlar.find((kur:any) => kur.para_birimi_id == this.localValue.para_birimi_id)) {
      let kur = new TakipTarihliKurEntity();
      kur.para_birimi = this.localValue.para_birimi;
      kur.para_birimi_id = this.localValue.para_birimi_id;
      kur.tutar = null;
      this.localValue.takip_tarihli_kurlar.push(kur);
    }
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY) {
      delete this.localValue.doviz_kur_tarihi;
      this.localValue?.asil_alacaklar?.forEach((asilAlacak: AlacakKalemiEntity) => {
        asilAlacak.para_birimi_id = this.paraBirimi.TRY;
        asilAlacak.para_birimi = this.paraBirimleri.find((paraBirimi: any) => (paraBirimi.id == this.paraBirimi.TRY));
      });
    } else if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.tahsilat) {
      this.localValue?.asil_alacaklar?.forEach((asilAlacak: AlacakKalemiEntity) => {
        asilAlacak.para_birimi_id = this.localValue.para_birimi_id;
        asilAlacak.para_birimi = this.localValue.para_birimi;
      });
    }
    this.addParaBirimi();
    this.input();
  }

  get isHideButtons() {
    return this.hideButtons || this.hideButtons === "";
  }

  get aciklama() {
    if (this.localValue.alacak_kalemi_turu) {
      if ((this.localValue.alacak_kalemi_turu.id == AlacakKalemiTuru.istirakNafakasi || this.localValue.alacak_kalemi_turu.id == AlacakKalemiTuru.yoksullukNafakasi) && this.localValue.cocuk_isim) {
        return this.localValue.cocuk_isim + " için " + this.localValue.alacak_kalemi_turu.isim + " Alacağı";
      }
      return this.localValue.alacak_kalemi_turu.isim + " Alacağı";
    }
  }

  get alacakKalemiRules() {
    if (this.localValue.aciklama) {
      if (this.localValue.aciklama.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return true;
  }

  private updateParaBirimiState() {
    const paraBirimiId = this.alacak.para_birimi_id;
    const dovizKurTarihi = this.alacak.doviz_kur_tarihi;
    const isForeignCurrency = paraBirimiId !== this.paraBirimi.TRY;
    this.readonlyParaBirimi = false;
    if (!isForeignCurrency) {
      this.localValue.para_birimi_id = this.paraBirimi.TRY;
      return;
    }
    switch (dovizKurTarihi) {
      case DovizTakipSekli.tahsilat:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
      case DovizTakipSekli.vade:
      case DovizTakipSekli.takip:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
    }
  }

  @Watch('alacak.para_birimi_id')
  onAlacakParaBirimiChange() {
    this.updateParaBirimiState();
  }

  @Watch('alacak.doviz_kur_tarihi')
  onAlacakDovizKurTarihiChange() {
    this.updateParaBirimiState();
    this.input();
  }

  @Watch("tarih")
  onVadeTarihiChange() {
    this.localValue.faiz_baslangic_tarihi = this.tarih;
  }

  @Watch("aciklama")
  onAciklamaChange() {
    this.localValue.aciklama = this.aciklama;
    this.input();
  }

  @Watch('localValue.tutar', { immediate: true })
  onTutarInit() {
    if (!this.originalTutarSet && this.localValue.id && this.localValue.tutar != null) {
      this.originalTutar = this.localValue.tutar;
      this.originalTutarSet = true;
    }
  }

  mounted() {
    if (this.localValue.id){
      this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;
    }else{
      this.localValue.takip_tarihli_kurlar = []
    }
    if (!this.localValue.is_devam_eden_aylar) {
      this.localValue.is_devam_eden_aylar = true;
    }
    this.updateParaBirimiState();
  }


}
